const isDevelopment = import.meta.env.MODE === 'development';

// Single source of truth for the backend URL — prefer the env var, fall back to dev/prod defaults
const backendUrl =
  import.meta.env.VITE_BACKEND_URL ||
  (isDevelopment ? 'http://localhost:2001' : 'https://api.hub.duo.tax');

export const appConfig = {
  env: import.meta.env.MODE,
  urls: {
    backend: backendUrl,
    frontend: isDevelopment ? 'http://localhost:6100' : 'https://hub.duo.tax',
  },
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    tenantId: import.meta.env.VITE_AZURE_TENANT_ID,
  },
  isVercelDeployment: import.meta.env.VERCEL_TEST === 'true',
};